import React from "react";

import Tabs from "../TabComponent/Tabs";

function Process() {
  return (
    <>
      <div id="our process" className="process-container">
        <div className="title-container">
          <p className="main-title">
            OUR PROCESS<span className="dot">.</span>
          </p>
          <p className="process-desc-txt">
            Our multi-stage process allows for flawless refinement and overall
            client satisfaction.
          </p>
        </div>
        <Tabs />
      </div>
    </>
  );
}

export default Process;
